import { AGENT_PERMISSIONS_ACTIONS } from "../../constants";

export const setAllowPlayRecordsOnCallHistory = (allowPlayRecordsOnCallHistory) => {
    return {
        type: AGENT_PERMISSIONS_ACTIONS.ALLOW_PLAY_RECORDS_ON_CALL_HISTORY,
        allowPlayRecordsOnCallHistory
    }
}

export function setAllowChangeDialing(data){
    return{
      type: AGENT_PERMISSIONS_ACTIONS.SET_ALLOW_CHANGE_DIALING,
      payload:data
    }
  }


// WEBPACK FOOTER //
// ./src/redux/actions/A_agent_permissions.js